import { createListReducer } from '../../../common/services/reducerCreator';

// Inline-edited list (referential view): the 4th arg ('RANKINGRULE') makes the
// reducer sync each row on UPDATE_RANKINGRULE_FULFILLED so the Valider button
// resets to pristine after a successful save (via redux-form enableReinitialize).
export default createListReducer('RANKING_RULES', [], undefined, 'RANKINGRULE');
